<template>
  <div>
    <div class="grid gap3 form-row">
      <FormInput
        class="grid-col-2"
        id="firstname"
        type="text"
        label="FIRST_NAME"
        placeholder="SPONSOR_FIRST_NAME"
        v-model:value="modelValue.firstname"
        v-model:errorMessage="errors.firstname"
      />

      <FormInput
        class="grid-col-2"
        id="lastname"
        type="text"
        label="LAST_NAME"
        placeholder="SPONSOR_LAST_NAME"
        v-model:value="modelValue.lastname"
        v-model:errorMessage="errors.lastname"
      />

      <FormInput
        class="grid-col-4"
        id="email"
        type="text"
        label="SPONSOR_EMAIL_REFERENCE"
        placeholder="SPONSOR_EMAIL"
        v-model:value="modelValue.email"
        v-model:errorMessage="errors.email"
      />
    </div>

    <div class="pt2">
      <div class="flex justify-between col-12 xs-hide sm-hide gap1 pt2">
        <ButtonV2 :disabled="disableFormButtons" color="light" :action="resetForm" :reference="'CANCEL'" rounded class="col-6 py1" />
        <ButtonV2 :disabled="disableFormButtons" color="dark" :action="saveForm" :reference="'SPONSOR'" rounded class="col-6 py1" />
      </div>
      <!-- Mobile -->
      <div class="flex flex-column justify-between col-12 pt2 gap2 md-hide lg-hide">
        <ButtonV2 :disabled="disableFormButtons" color="light" :action="resetForm" :reference="'CANCEL'" rounded class="col-12 py1" />
        <ButtonV2 :disabled="disableFormButtons" color="dark" :action="saveForm" :reference="'SPONSOR'" rounded class="col-12 py1" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import FormInput from '@/components/inputs/FormInput';
import ButtonV2 from '@/components/elements/ButtonV2';
import { getReferencelabel } from '@/mixins/utils';
import { validateForm } from '@/mixins/formValidation';
import { isObjectEmpty } from '../../mixins/utils';

export default {
  name: 'NewReferralForm',
  components: { FormInput, ButtonV2 },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['save-form', 'reset-form'],

  setup(props, { emit }) {
    const errors = ref({});

    const referralFormValidations = {
      firstname: {
        rules: ['required', 'min:2'],
        regex: /^([A-Za-z-'\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/,
        errorMessages: {
          required: 'FIRST_NAME_ERROR',
          min: 'FIRST_NAME_MORE_2',
          regex: 'FIRST_NAME_ONLY_LETTERS'
        }
      },
      lastname: {
        rules: ['required', 'min:2'],
        regex: /^([A-Za-z-'\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/,
        errorMessages: {
          required: 'LASTNAME_ERROR',
          min: 'LASTNAME_MORE_2',
          regex: 'LASTNAME_ONLY_LETTERS'
        }
      },
      email: {
        rules: ['required', 'email'],
        errorMessages: {
          required: 'ERROR_EMAIL_EMPTY',
          email: 'ERROR_WRONG_EMAIL'
        }
      }
    };

    const disableFormButtons = computed(() => {
      return isObjectEmpty(props.modelValue) || !(Object.keys(props.modelValue).find(key => {
        return !!props.modelValue[key]
      }))
    })

    const saveForm = () => {
      if (disableFormButtons.value) {
        return
      }

      errors.value = validateForm(props.modelValue, referralFormValidations);
      if (Object.keys(errors.value).length) {
        return;
      }
      emit('save-form');
    };

    const resetForm = () => {
      if (disableFormButtons.value) {
        return
      }

      errors.value = {};
      emit('reset-form');
    };

    return {
      errors,
      getReferencelabel,
      saveForm,
      resetForm,
      disableFormButtons
    };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}
</style>
